import { render, staticRenderFns } from "./AddMotifcategoryDlg.vue?vue&type=template&id=2d9f462e&"
import script from "./AddMotifcategoryDlg.vue?vue&type=script&lang=js&"
export * from "./AddMotifcategoryDlg.vue?vue&type=script&lang=js&"
import style0 from "./AddMotifcategoryDlg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports